import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const ResearchIcon = createIcon({
  displayName: 'ResearchIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <path d="M19.121,14.879c1.297,1.297 1.158,3.488 -0.418,4.593c-1.003,0.703 -2.403,0.703 -3.406,0c-1.576,-1.106 -1.716,-3.296 -0.418,-4.593c1.171,-1.172 3.071,-1.172 4.242,-1.77636e-15" />
        <path d="M19.121,19.121l1.879,1.879" />
        <path d="M8,10h-3c-1.105,0 -2,-0.895 -2,-2v-3c0,-1.105 0.895,-2 2,-2h3c1.105,0 2,0.895 2,2v3c0,1.105 -0.895,2 -2,2Z" />
        <path d="M19,10h-3c-1.105,0 -2,-0.895 -2,-2v-3c0,-1.105 0.895,-2 2,-2h3c1.105,0 2,0.895 2,2v3c0,1.105 -0.895,2 -2,2Z" />
        <path d="M8,21h-3c-1.105,0 -2,-0.895 -2,-2v-3c0,-1.105 0.895,-2 2,-2h3c1.105,0 2,0.895 2,2v3c0,1.105 -0.895,2 -2,2Z" />
      </g>
      <path
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        d="M0,0h24v24h-24Z"
        transform="matrix(-1,-1.22465e-16,1.22465e-16,-1,24,24)"
      />
    </>
  ),
})

const Research: FC<IconProps> = (props) => {
  return <CustomIcon as={ResearchIcon} {...props} />
}

export default memo(Research)
